import { combineLatest, Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { PaymentService } from '@core/services/payment/payment.service';
import { PaymentStoreDispatcher } from '@common/dispatchers/payment.dispatcher';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-pat-payment-panel-paygreen-generic',
  template: ``,
  standalone: false,
})
export class PatPaymentPanelPaygreenGenericComponent implements OnInit, OnDestroy {
  private readonly unsubscribe$ = new Subject<boolean>();

  constructor(
    private readonly paymentService: PaymentService,
    private paymentDispatcher: PaymentStoreDispatcher,
    private readonly analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    this.paymentDispatcher.updateUI({
      button: {
        isEnabled: false,
      },
      status: {
        isLoading: true,
      },
    });

    combineLatest([this.paymentService.pay$, this.paymentService.paymentPaygreenIntent$])
      .pipe(
        takeUntil(this.unsubscribe$),
        take(1),
        map(([, paymentIntent]) => {
          if (paymentIntent?.payment_page_url) {
            window.location.href = paymentIntent.payment_page_url;
          } else {
            throw new Error('Payment intent is undefined');
          }
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
}
